module.exports = __webpack_public_path__ + "img/shopping.ea6396b9.svg";